interface NoDataProps {
  message?: string;
}

const NoData: React.FC<NoDataProps> = ({message = 'No Data'}) => {
  return <div>{message}</div>;
};

export default NoData;
